export default __webpack_public_path__ + "img/bmgnYWyO.bba812b5.svg";